import { apiEndpoints, CommandResult, PortalLoginOptions, PortalSharedResourceType, PortalSharedResourceView } from '../amorg-common';
import { commandAuthWrapper, queryAuthWrapper } from './serverApiHelpers';

export const portalClientApi = {

    getLoginOptions: async (siteId: string): Promise<PortalLoginOptions> =>
        await queryAuthWrapper(apiEndpoints.portal_login_siteId_options.replace(':siteId', siteId)),

    requestMagicLink: async (siteIdOrLoginName:string, email:string): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_login_siteId_magicLink_request.replace(':siteIdOrLoginName', siteIdOrLoginName), 'POST',
            { email }),

    confirmMagicLink: async (siteId:string, email:string, requestId:string): Promise<boolean> =>
    {
         const response = await fetch(apiEndpoints.portal_login_siteId_magicLink_confirm.replace(':siteId', siteId).replace(':email', email).replace(':requestId', requestId),
            {
                method:'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.status === 200;
    },

    sharePortalResource: async (resourceType: PortalSharedResourceType, resourceId: string, config: { note: string }): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_shared_resources, 'POST', { resourceType, resourceId, config }),

    unsharePortalResource: async (resourceType: PortalSharedResourceType, resourceId: string): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_shared_resources_type_id.replace(':resourceType', resourceType).replace(':resourceId', resourceId), 'DELETE'),

    getPortalFiles: async (): Promise<PortalSharedResourceView[]> =>
    {
        const resources = await queryAuthWrapper(apiEndpoints.portal_shared_resources) as PortalSharedResourceView[];
        return resources
            .filter(resource => resource.resourceType === 'DocumentArchiveFile')
            .map(resource => ({
                ...resource,
                created: new Date(resource.created)
            }));
    },

    accessKeyLogin: async (siteId:string, accessKey:string): Promise<boolean> =>
    {
         const response = await fetch(apiEndpoints.portal_access_key_siteId_accessKey.replace(':siteId', siteId).replace(':accessKey', accessKey),
            {
                method:'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.status === 200;
    }
}